import { render, staticRenderFns } from "./reservationSuccess.vue?vue&type=template&id=bb22b3da&scoped=true"
import script from "./reservationSuccess.vue?vue&type=script&lang=js"
export * from "./reservationSuccess.vue?vue&type=script&lang=js"
import style0 from "./reservationSuccess.vue?vue&type=style&index=0&id=bb22b3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb22b3da",
  null
  
)

export default component.exports